<script lang="ts" setup>
import { useToast } from "../services/toast";

const { toasts } = useToast();
</script>

<template>
    <div
        aria-live="polite"
        aria-atomic="true"
        class="fixed w-100"
    >
        <div class="idoltoast--container">
            <div
                v-for="tst in toasts"
                :key="tst.id"
                class="idoltoast sessioncamlogerror"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
                @mouseover="tst.touch"
            >
                <div class="toast-header">
                    <strong class="me-auto">{{ tst.title }}</strong>
                    <button
                        type="button"
                        class="btn-close toastBtnClose"
                        data-bs-dismiss="toast"
                        aria-label="Close"
                        @click="tst.close"
                    />
                </div>
                <div v-if="tst.useUnsafeHTMLMessage">
                    <div
                        class="toast-body"
                        v-html="tst.message"
                    />
                </div>
                <div v-else>
                    <div
                        class="toast-body"
                    >
                        {{ tst.message }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.idoltoast--container {
    width: 100%;
    top: 0;
    z-index: 50;
}

.idoltoast {
    background-color: white;
    padding: 20px;
    margin: 0 auto;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9851;
    box-shadow: 0 22px 70px 4px rgb(0 0 0 / 56%);
    border-radius: 7px;
}

.toast-header {
    font-size: 135%;
    margin-bottom: 15px;
}

.toastBtnClose {
    background-image: url("../assets/images/icon-cross.svg");
    border: none;
    background-color: white;
    width: 2px;
    height: 2px;
    margin-left: 5px;
    opacity: 0.5;
    background-size: contain;
}

.toastBtnClose:hover {
    opacity: 1;
}

</style>
